export default [
  {
    code: 'S',
    label: 'Sympathisant',
    text: 'S - Sympathisant',
    indentText: 'S - Sympathisant',
    background: 'green',
    color: 'white--text',
    political: true,
  },
  {
    code: 'A',
    label: 'Adversaire',
    text: 'A - Adversaire',
    indentText: 'A - Adversaire',
    background: 'red',
    color: 'white--text',
    political: true,
  },
  {
    code: 'PLQ',
    label: 'Parti Libéral',
    text: 'PLQ - Parti Libéral',
    indentText: ' &nbsp;&nbsp;&nbsp; PLQ - Parti Libéral',
    background: 'red',
    color: 'white--text',
    political: true,

  },
  {
    code: 'PQ',
    label: 'Parti Québécois',
    text: '  PQ - Parti Québécois',
    indentText: ' &nbsp;&nbsp;&nbsp; PQ - Parti Québécois',
    background: 'red',
    color: 'white--text',
    political: true,

  },
  {
    code: 'QS',
    label: 'Québec Solidaire',
    text: '  QS - Québec Solidaire',
    indentText: ' &nbsp;&nbsp;&nbsp; QS - Québec Solidaire',
    background: 'red',
    color: 'white--text',
    political: true,

  },
  {
    code: 'PC',
    label: 'Parti Conservateur',
    text: '  PC - Parti Conservateur',
    indentText: ' &nbsp;&nbsp;&nbsp; PC - Parti Conservateur',
    background: 'red',
    color: 'white--text',
    political: true,

  },
  {
    code: 'NPDQ',
    label: 'Nouveau Parti démocratique du Québec',
    text: '  NPDQ - Nouveau Parti démocratique du Québec',
    indentText: ' &nbsp;&nbsp;&nbsp; NPDQ - Nouveau Parti démocratique du Québec',
    background: 'red',
    color: 'white--text',
    political: true,

  },
  {
    code: 'I',
    label: 'Indécis',
    text: '  I - Indécis',
    indentText: 'I - Indécis',
    background: '',
    color: '',
    political: true,
  },


  {
    code: 'D',
    label: 'Déménagé',
    text: 'D - Déménagé',
    indentText: 'D - Déménagé',
    background: 'grey darken-3',
    color: 'white--text',
    political: false,
  },
  {
    code: 'NVP',
    label: 'Ne vote pas',
    text: 'NVP - Ne vote pas',
    indentText: 'NVP - Ne vote pas',
    background: 'grey darken-3',
    color: 'white--text',
    political: false,
  },
  {
    code: 'X',
    label: 'Décédé',
    text: 'X - Décédé',
    indentText: 'X - Décédé',
    background: 'grey darken-3',
    color: 'white--text',
    political: false,
  },
  {
    code: 'MN',
    label: 'Mauvais numéro',
    text: 'MN - Mauvais numéro',
    indentText: 'MN - Mauvais numéro',
    background: 'grey darken-3',
    color: 'white--text',
    political: false,
  },
  {
    code: 'AB',
    label: 'Absent',
    text: 'AB - Absent',
    indentText: 'AB - Absent',
    background: 'grey darken-3',
    color: 'white--text',
    political: false,
  },
  {
    code: 'DV',
    label: 'Déjà voté',
    text: 'DV - Déjà voté',
    indentText: 'DV - Déjà voté',
    background: 'grey darken-3',
    color: 'white--text',
    political: false,
  },
  {
    code: 'RE',
    label: 'Refus de répondre',
    text: 'RE - Refus de répondre',
    indentText: 'RE - Refus de répondre',
    background: 'red',
    color: 'white--text',
    political: false,
  },
]
